import { render } from "./SingleCardPicker.vue?vue&type=template&id=4a632fcd&scoped=true"
import script from "./SingleCardPicker.vue?vue&type=script&lang=js"
export * from "./SingleCardPicker.vue?vue&type=script&lang=js"

import "./SingleCardPicker.vue?vue&type=style&index=0&id=4a632fcd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4a632fcd"

export default script